import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {CreaListinoComponent} from './crea-listino';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.crea-listino', {
            url: '/crea-listino',
            params: {
              email: 'testgg3@test.com'
            },
            ncyBreadcrumb: {
                label: 'crea-listino',
                parent: 'home.gestione-profili'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'crea-listino'
            },
            'views': {
                'homeContent': {
                    template: '<crea-listino flex="100"></crea-listino>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const CreaListinoModule: string = ng
    .module('crea-listino', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('creaListino', CreaListinoComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/crea-listino/crea-listino.module.ts